module.exports = __webpack_public_path__ + "15ccbf5a95db6d40c64acd20172deb2a.png";